import React from "react";

export default function MyWorkAttentionCards({ attention, onSelect }) {
  const cards=[
    ["sla_breached","SLA Breached","fas fa-exclamation-triangle","danger","OVERDUE"],
    ["sla_warning","SLA Warning","fas fa-clock","warning","ALL"],
    ["due_today","Due Today","fas fa-calendar-day","primary","DUE_TODAY"],
    ["escalated","Escalated","fas fa-level-up-alt","danger","ESCALATED"],
    ["pending_approval","Pending Approval","fas fa-user-check","purple","APPROVALS"],
    ["pending_execution","Pending Execution","fas fa-play","success","EXECUTION"]
  ];
  return <><div className="my-work-section-title"><i className="fas fa-bell"/>NEEDS MY ATTENTION</div>
  <div className="my-work-attention">{cards.map(([key,label,icon,tone,tab])=>
    <div key={key} className={`my-work-attention-card attention-${tone}`} role="button" tabIndex={0}
      onClick={()=>onSelect(tab)} onKeyDown={e=>e.key==="Enter"&&onSelect(tab)}>
      <div className="attention-icon"><i className={icon}/></div><div className="attention-label">{label}</div><div className="attention-value">{attention[key]||0}</div>
    </div>)}</div></>;
}